module.exports = __webpack_public_path__ + "static/WSC_Group_2016_Business_Checklist-90b19966fd27b294f529a5ddd65fe046.pdf";